import { mapFilterOptionsToMutations } from '../utils/vehicleFilters';
import * as constants from '../constants';

const mutations = {
  [constants.LEVEL4_CATEGORIES_FETCH]: (state, categories) => {
    state.categories = categories;
  },
  [constants.LEVEL4_CONDITIONS_FETCH]: (state, conditions) => {
    state.conditions = conditions;
  },
  [constants.LEVEL4_SEARCH_DATA]: (state, searchData) => {
    state.searchData = searchData;
  },
  [constants.LEVEL4_SEARCH_DATA_CURRENT]: (state, searchData) => {
    state.searchDataCurrent = searchData;
  },
  [constants.LEVEL4_BOARDS_FETCH]: (state, boards) => {
    state.boards = boards;
  },
  [constants.LEVEL4_BOARD_FETCH]: (state, board) => {
    state.board = board;
  },
  [constants.LEVEL4_HOTSPOTS_FETCH]: (state, hotspots) => {
    state.hotspots = hotspots;
  },
  [constants.LEVEL4_VEHICLE_DATA]: (state, vehicleData) => {
    state.vehicleData = vehicleData;
  },
  [constants.LEVEL4_CATEGORIES_PATH_PUSH]: (state, categoriesPath) => {
    state.categoriesPath.push(categoriesPath);
  },
  [constants.LEVEL4_CATEGORIES_PATH_EMPTY]: (state) => {
    state.categoriesPath = [];
  },
  [constants.LEVEL4_VEHICLE_CURRENT_FILTERS]: (state, vehicleCurrentFilters) => {
    state.vehicleCurrentFilters = vehicleCurrentFilters;
  },
  ...mapFilterOptionsToMutations(constants.vehicleFiltersBasicTypes),
  ...mapFilterOptionsToMutations(constants.vehicleFiltersVehicleTypes),
};

export default mutations;
